import { useCallback } from "react";
import { HOME_SEARCH_QUERY_PARAM } from "@core/constants";

export default function useApplySearch() {
    return useCallback((search: string) => {
        window.location.href = `/?${HOME_SEARCH_QUERY_PARAM}=${encodeURIComponent(search)}`;
    }, []);
}